import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { notesRequiringApprovalSchema, notesPendingActionSchema, pndueSchema, dcdueSchema, specProgReqMsgsSchema, federalReviewMsgsSchema, mcDiaryItemsSchema } from '_services/_schemas';

export const messageCenterService = {
    loadNotesRequiringApproval,
    approveAllNotesRequiringApproval,
    approveNoteRequiringApproval,
    rejectNoteRequiringApproval,
    markRead,
    loadNotesPendingAction,
    closeNotifications,
    closeNotification,
    markReadNotification,
    loadPNDue,
    loadPNDueDetails,
    loadDCDue,
    markReadPNDCDue,
    loadSpecProgReqs,
    prwsReply,
    loadFederalReviews,
    loadDiaryItems,
    markReadDiaryItem,
    resolveDiaryItem
};

async function loadNotesRequiringApproval() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/notesrequiringapproval', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesRequiringApprovalSchema);
            return flat;
        });
}

async function approveAllNotesRequiringApproval(noteIds) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteIds })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/approveallnotesreqapproval', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesRequiringApprovalSchema);
            return flat;
        });
}


async function approveNoteRequiringApproval(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/approvenotereqapproval', requestOptions, true)
        .then(data => {
            return data
        });
}

async function rejectNoteRequiringApproval(noteId, rejectReason) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId, rejectReason })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/rejectnotereqapproval', requestOptions, true)
        .then(data => {
            return data
        });

}

async function markRead(noteId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ noteId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/markreadnotereqapproval', requestOptions, true)
        .then(data => {
            return data
        });

}

async function loadNotesPendingAction() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/notespendingaction', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesPendingActionSchema);
            return flat;
        });
}


async function closeNotifications(nonos) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nonos })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/closenotifications', requestOptions, true)
        .then(data => {
            var flat = normalize(data, notesPendingActionSchema);
            return flat;
        });
}


async function closeNotification(nono) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nono })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/closenotification', requestOptions, true)
        .then(data => {
            return data
        });
}

async function markReadNotification(nono) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nono })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/markreadnotification', requestOptions, true)
        .then(data => {
            return data
        });

}

async function loadPNDue() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/pndue', requestOptions, true)
        .then(data => {
            var flat = normalize(data, pndueSchema);
            return flat;
        });
}

async function loadPNDueDetails(epno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/pnduedetails?epno=' + epno, requestOptions, true);
}

async function loadDCDue() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/dcdue', requestOptions, true)
        .then(data => {
            var flat = normalize(data, dcdueSchema);
            return flat;
        });
}

async function markReadPNDCDue(epno, pndate, ispndue, ispocdue, isdcdue) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, pndate, ispndue, ispocdue, isdcdue })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/markreadpndcdue', requestOptions, true)
        .then(data => {
            return data
        });

}

async function loadSpecProgReqs() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/specprogreqs', requestOptions, true)
        .then(data => {
            var flat = normalize(data, specProgReqMsgsSchema);
            return flat;
        });
}


async function prwsReply(sxno, mxno, odno, reply, toUrno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sxno, mxno, odno, reply, toUrno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/prwsreply', requestOptions, true)
        .then(data => {
            return data
        });

}


async function loadFederalReviews() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/federalreviews', requestOptions, true)
        .then(data => {
            var flat = normalize(data, federalReviewMsgsSchema);
            return flat;
        });
}


async function loadDiaryItems() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/diaryitems', requestOptions, true)
        .then(data => {
            var flat = normalize(data, mcDiaryItemsSchema);
            return flat;
        });
}


async function markReadDiaryItem(dlno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dlno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/markreaddiaryitem', requestOptions, true)
        .then(data => {
            return data
        });

}

async function resolveDiaryItem(dlno, resolveMsg) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dlno, resolveMsg })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/messagecenter/resolvediaryitem', requestOptions, true)
        .then(data => {
            return data
        });

}
